import type { FC } from 'react';
import type { Line } from '../copy';

// Renders a single line of copy from the typed copy model. Handles both
// inline word emphasis (span.strong) and whole-line emphasis (line.bold).
export const CopyLine: FC<{ line: Line; className?: string }> = ({ line, className }) => {
  const classes = [className, line.bold ? 'font-semibold' : ''].filter(Boolean).join(' ');
  return (
    <span className={classes}>
      {line.spans.map((span, i) =>
        span.strong ? (
          <strong key={i} className="font-semibold">
            {span.text}
          </strong>
        ) : (
          <span key={i}>{span.text}</span>
        ),
      )}
    </span>
  );
};
